import angular from 'angular';
import specificActListComponent from './specific-act-list.component';
import specificActListService from './specific-act-list.service';
import specificActListConfig from './specific-act-list.config';

let specificActListModule = angular.module('app.specificActList',[])
  .component('specificActList', specificActListComponent)
  .service('specificActListService', specificActListService)
  .config(specificActListConfig);

export default specificActListModule;






/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/specific-act-list/specific-act-list.js
 **/